import classNames from 'classnames'
import { MyIcon } from '~/components/ui/MyIcon'

interface Props {
  col: string
  setCol: (n: string) => void
}

export default function LayoutSwitch({ col, setCol }: Props) {
  return (
    <div className="flex items-center bg-neutral-200 rounded-2xl px-2 py-1 gap-2">
      <div onClick={() => setCol('4')} className="leading-none">
        <MyIcon
          icon="layout-4"
          className={classNames('cursor-pointer text-[16px]', {
            'text-neutral-800': col === '4',
          })}
        ></MyIcon>
      </div>

      <div onClick={() => setCol('6')} className="leading-none">
        <MyIcon
          icon="layout-8"
          className={classNames('cursor-pointer text-[16px]', {
            'text-neutral-800': col === '6',
          })}
        ></MyIcon>
      </div>

      <div onClick={() => setCol('8')} className="leading-none">
        <MyIcon
          icon="layout-16"
          className={classNames('cursor-pointer text-[16px]', {
            'text-neutral-800': col === '8',
          })}
        ></MyIcon>
      </div>
    </div>
  )
}
